'use client';

import { useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { Box } from '@eqi-investimentos/react';
import { envConfig } from '@/config/env';

export const UserGuidingScript = () => {
  const { data: session } = useSession();

  useEffect(() => {
    if (typeof window !== 'undefined' && session && session.user) {
      window.userGuiding.identify(session.user.id, {
        name: session.user.name || 'Anonimo',
        created_at: Date.now(),
        email: session.user.email,
      });
    }
  }, [session]);

  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: `<script>  (function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];var k=u.createElement(i);k.async=true;k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';f.parentNode.insertBefore(k,f);if(g[d])return;var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};var m=['previewGuide','finishPreview','track','identify','hideChecklist','launchChecklist'];for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}})(window,document,'script','userGuiding','userGuidingLayer','${envConfig.userGuiding.containerId}');</script>`,
      }}
    />
  );
};
